// 管理员菜单

let menuDxmbzjl = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path:'/p1',
    //     redirect: '/common/projectPreparation',
    //     component: "HomeView",
    //     name: '运营管理',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"项目进度",
    //             children:[
                    
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/fileList",
    //                 //     path:"/common/fileList",
    //                 //     component:"fileList",
    //                 //     name:"项目资料管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/projectManage/fileDetail",
    //                     path:"/common/fileDetail",
    //                     component:"fileDetail",
    //                     hidden:true,
    //                     name:"项目资料详情"
    //                 },
    //             ]
    //         },
    //     ]

    // },
    
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     redirect:'/common/engineerList0',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"质监管理",
    //             children:[
                    
    //                 // {
    //                 //     pageAddress:"commonPage/broadHeading/LargeProject",
    //                 //     path:"/common/LargeProject",
    //                 //     component:"engineerList",
    //                 //     name:"大项目管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/enginnerManage/engineerDetail",
    //                     path:"/common/engineerDetail",
    //                     hidden:true, 
    //                     component:"engineerDetail",
    //                     name:"工程详情"
    //                 },
                    
    //             ]
    //         },
            
    //     ]
    // },
    
    {
		path:'/p8',
        redirect: '/user/index',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     path: '/me/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },	
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    }, 
    {
        pageAddress:"commonPage/financeManage/NewXiangmushitu",
        path:"/common/New",
        hidden:true,
        name:"项目视图新建页面导出数据"
    },
    {   
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"commonPage/financeManage/serviceFeePrint",
        path:"/common/serviceFeePrint",
        hidden:true,
        // name:"打印劳务支付"
    },
    {
        pageAddress:"commonPage/enginnerManage/finishProjectTable",
        path:"/common/finishProjectTable",
        component:"finishProjectTable",
        hidden:true,
        // name:"竣工验收记录表"
    },
    {
        pageAddress:"commonPage/enginnerManage/startProjectTable",
        path:"/common/startProjectTable",
        component:"startProjectTable",
        hidden:true,
        // name:"开工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/finishProjectTable",
        path:"/common/finishProjectTable",
        component:"finishProjectTable",
        hidden:true,
        // name:"竣工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/constructionScoreDetail",
        path:"/common/constructionScoreDetail",
        component:"constructionScoreDetail",
        hidden:true,
        // name:"工地检查评分统计表"
    },
    {
        pageAddress:"commonPage/enginnerManage/returnVisitTable",
        path:"/common/returnVisitTable",
        component:"returnVisitTable",
        hidden:true,
        // name:"回访表"
    }
]

export default menuDxmbzjl;


// WEBPACK FOOTER //
// ./src/menu/menuDxmbzjl.js